module.exports = __webpack_public_path__ + "img/filecoin.7b83b6f8.png";